<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="'Submit'"
  >
    <template slot="header">
      <span>{{ status_id == glassStatusIdNew ? 'Issue' : 'Undo Issue' }} PO# {{ po_number }}</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          v-if="status_id == glassStatusIdNew"
          cols="12"
        >
          <v-autocomplete
            v-model="location_id"
            :items="locations"
            auto-select-first
            item-text="name"
            item-value="id"
            :rules="[(v) => !!v || 'Expected Shipping Location is required']"
          >
            <template slot="label">
              Expected Shipping Location<RedAsterisk />
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    status_id: null,
    po_number: null,
    inventory_class_id: null,
    location_id: null,
    locations: [],
    glassStatusIdNew: 1,
    glassStatusIdIssued: 17,
  }),
  created() {
  },
  methods: {

    async getLocations() {
      this.locations = await this.$api.location.getList();
    },

    async submit() {
      this.$bus.$emit('loading');
      const submitModel = {
        po_number: this.po_number,
        inventory_class_id: this.inventory_class_id,
        status_id: this.status_id === this.glassStatusIdNew ? this.glassStatusIdIssued : this.glassStatusIdNew,
        location_id: this.location_id,
      };
      const res = await this.$api.glass.store(submitModel, 'po-status-issued');
      this.$bus.$emit('loading');

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$emit('success');
      return res;
    },

    open(item) {
      this.$refs.dialogBox.open();
      this.item = item;
      this.po_number = item.po_number;
      this.inventory_class_id = item.inventory_class_id;
      this.status_id = item.status_id;
      this.getLocations();
    },
  },
};
</script>
